module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/subscribers/subscriber-list/subscriber-list.component.scss
// module id = ./src/app/subscribers/subscriber-list/subscriber-list.component.scss
// module chunks = main